var map = {
	"./glassCases/w1/przekroj.png": 64505,
	"./glassCases/w4/przekroj.png": 93084,
	"./glassCases/w6/przekroj.png": 30992,
	"./glassCases/w7/przekroj.png": 57171,
	"./handles/p45/przekroj.png": 56292,
	"./handles/uc/przekroj.png": 2584,
	"./handles/uk/przekroj.png": 71879,
	"./handles/uk45/przekroj.png": 46133,
	"./handles/up/przekroj.png": 9668,
	"./handles/up45/przekroj.png": 18768,
	"./millings/E1/przekroj.png": 96362,
	"./millings/E2/przekroj.png": 69270,
	"./millings/E3/przekroj.png": 92901,
	"./millings/J1/przekroj.png": 56466,
	"./millings/J10/przekroj.png": 90894,
	"./millings/J12/przekroj.png": 36319,
	"./millings/J13/przekroj.png": 84866,
	"./millings/J2/przekroj.png": 62753,
	"./millings/J3/przekroj.png": 31881,
	"./millings/J4/przekroj.png": 22626,
	"./millings/J5/przekroj.png": 52846,
	"./millings/J6/przekroj.png": 95246,
	"./millings/J7/przekroj.png": 15704,
	"./millings/J8/przekroj.png": 87335,
	"./millings/J9/przekroj.png": 73756,
	"./millings/ryflowany/przekroj.png": 56085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80057;